<template>
  <div>
    <div class="row">
      <div class="col">
        <sub-header-grey class="pt-2 pb-2 RegistrosAnteriores_header">
          <span>Vinculação de Registros anteriores</span>
        </sub-header-grey>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <registros-anteriores-resultados v-if="propRegistros.length > 0"
                                         :prop-radio="false"
                                         :prop-vinculado="true"
                                         :prop-resultados="propRegistros"
                                         :prop-disable-edit="true"
                                         :prop-show-dissolucao="propShowDissolucao"
                                         :prop-pessoa="propData"
                                         @onEdit="(registro, index, edit) => editRegistroAnterior(registro, index, edit)"
                                         @onDeleteRegistroAnterior="(index) => $emit('registroRemoved', index)"
                                         @changed="$emit('changed')" />
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <b-button variant="outline-primary"
                  :class="`btn-add-registro btn btn-sm btn-block my-2 addRegistro_${propOrdem}`"
                  @click="show.registros_anteriores = true">
          <IconSvg class="icon-add icon--sm mr-1"
                   icon="add" />
          Adicionar registro anterior
        </b-button>
      </div>
    </div>

    <b-modal v-if="show.registros_anteriores"
             id="RegistrosAnteriores-modal-busca"
             size="xl"
             class="RegistrosAnteriores--modal"
             visible
             hide-header
             hide-footer
             no-close-on-backdrop
             no-close-on-esc
             @hide="onHideModal">
      <div v-if="!show.manual">
        <collapse-default :id="`registros_anteriores_${ _uid }`"
                          icons-class="icon--xxs"
                          :style-default="true"
                          header-class="header-blue"
                          :collapse-visible="resultados.length == 0"
                          :icons-show="true"
                          @onCollapseShow="collapseClick">
          <template v-slot:header>
            Buscar <small v-if="resultados.length > 0"
                          class="text-bold text-info">(Clique aqui para mostrar os filtros de pesquisa)</small>
          </template>

          <template v-slot:content>
            <registros-anteriores-busca :prop-data="propData"
                                        class="mt-2"
                                        @onGetRegistros="(registros, busca) => getRegistrosBusca(registros, busca)" />
          </template>
        </collapse-default>

        <div v-if="resultados.length > 0"
             :class="{ 'mt-3': resultados.length > 0 }"
             class="row no-gutters">
          <div class="col" />
          <div class="col">
            <!--<Pagination
              :per-page="10"
              :page="1"
              :last-page="10"
              @onPreviousPage="previousPage"
              @onNextPage="nextPage" />-->
          </div>
          <div class="col">
            <div class="row no-gutters">
              <div class="col d-flex align-items-center justify-content-end">
                <label for=""
                       class="label">
                  Ordenar por:
                </label>
              </div>
              <div class="col-6 ml-1">
                <v-select v-model="ordenacao"
                          :options="optionsOrdenacao"
                          class="form-control form-control-sm"
                          @input="ordenacaoChanged" />
              </div>
            </div>
          </div>
        </div>
        <registros-anteriores-resultados v-if="resultados.length > 0"
                                         :prop-tipo-registro="tipo_registro"
                                         :prop-registro="propRegistro"
                                         :prop-radio="true"
                                         class="RegistrosAnteriores_resultado"
                                         :prop-resultados="convertToSofia(resultados)"
                                         @onSelectedRegistro="(registro) => updateRegistroSelecionado(registro)"
                                         @onEdit="(registro, index) => editRegistroAnterior(registro, index)" />
      </div>
      <div v-if="show.manual">
        <registros-anteriores-manual :prop-registro="manual"
                                     :prop-busca="convertToSofia(busca)"
                                     :prop-data="propData"
                                     :prop-tipo-registro="tipo_registro"
                                     @onGoToBack="goToBack"
                                     @onChanged="(index, registro) => updateManual(index, registro)"
                                     @onVincular="vincular" />
      </div>
      <div v-if="!show.manual"
           class="row pt-2 pb-3">
        <div class="col text-right">
          <hr class="RegistrosAnteriores--hr pt-0 mt-0">
          <b-button size="sm"
                    variant="light"
                    @click="goToBack">
            Voltar
          </b-button>
          <b-button size="sm"
                    class="ml-2"
                    :disabled="resultados.length == 0 && Object.values(busca).length == 0"
                    variant="outline-secondary"
                    @click="showManual()">
            Registro Não Encontrado
          </b-button>
          <b-button size="sm"
                    class="ml-2"
                    :disabled="!(registroSelecionado != null || show.manual)"
                    variant="secondary"
                    @click="vincular(), reset()">
            Vincular
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import RegistrosAnterioresBusca from "@/components/SofiaRei/RegistrosAnteriores/RegistrosAnterioresBusca"
  import RegistrosAnterioresResultados from "@/components/SofiaRei/RegistrosAnteriores/RegistrosAnterioresResultados"
  import RegistrosAnterioresManual from "@/components/SofiaRei/RegistrosAnteriores/RegistrosAnterioresManual"
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"

  export default {
    name: "RegistrosAnteriores",
    components: {
      SubHeaderGrey,
      RegistrosAnterioresBusca,
      RegistrosAnterioresResultados,
      RegistrosAnterioresManual,
      CollapseDefault
    },
    props: {
      propRegistros: {
        type: Array,
        default: () => ([])
      },
      propData: {
        type: Object,
        default: () => ({})
      },
      propRegistro: {
        type: Object,
        default: () => ({})
      },
      propOrdem: {
        type: Number,
        default: 0
      },
      propShowDissolucao: { type: Boolean, default: false }
    },
    data () {
      return {
        registroSelecionado: null,
        resultados: [],
        ordenacao: null,
        manual: {
          index: null,
          registro: {}
        },
        tipo_registro: null,
        busca: {},
        show: {
          registros_anteriores: false,
          manual: false
        }
      }
    },
    computed: {
      optionsOrdenacao () {
        //['Nome registrado', 'Nome cônjuge', 'Livro', 'Registro']
        const options = [
          {
            label: `Nome registrado`,
            value: `nome_registrado_completo`,
            types: [`N`, `O`, `C`, `TC`]
          },
          {
            label: `Nome cônjuge`,
            value: `nome_reg_2_completo`,
            types: [`C`, `TC`]
          },
          {
            label: `Livro`,
            value: `num_livro`,
            types: [`N`, `O`, `C`, `TC`]
          },
          {
            label: `Registro`,
            value: `num_registro`,
            types: [`N`, `O`, `C`, `TC`]
          }
        ]

        return options.filter(option => {
          if (option.types.indexOf(this.tipo_registro) != -1) return option
        })
      }
    },
    methods: {
      showManual () {
        this.manual = {
          index: null,
          registro: {}
        }
        this.show.manual = true
      },
      goToBack () {
        // caso adicionar manual esteja aberto, ele voltará para a busca
        if (this.show.manual) {
          this.show.manual = false
        } else if (this.resultados.length > 0) {
          // setando resultados para array vázio para mostrar os filtros de busca
          this.resultados = []
        } else {
          // seta variável para esconder registros anteriores
          this.show.registros_anteriores = false
        }
        Object.assign(this.manual, { index: null, registro: {} })
      },
      collapseClick () {
        this.resultados = []
        this.busca = {}
      },
      limparDados (data) {
        data.cpf_registrado = data.cpf_registrado && data.cpf_registrado.replace(/[.,-]/g, '')
        data.matricula = data.matricula && data.matricula.replace(/[' ']/g, '')

        if ((this.manual.registro && this.manual.registro.cidade) || this.busca.cidade) {
          data.cidade = this.manual.registro && this.manual.registro.cidade || this.busca.cidade
        }

        Object.assign(data, {
          livro: data.livro != 0 ? data.livro : null,
          folha: data.folha != 0 ? data.folha : null,
          termo: data.termo != 0 ? data.termo : null
        })

        return data
      },
      vincular () {
        if (this.manual.registro.registrado == 'conjuge') {
          const { nome_registrado, conjuge } = this.manual.registro

          const registroAnterior = {
            ...this.manual.registro,
            ...{
              nome_registrado: conjuge,
              conjuge: nome_registrado
            }
          }

          this.manual.registro = registroAnterior
        }

        if (this.show.manual && this.resultados.length > 0) {
          // editando registro listado na busca e caso não tenha achado
          if (this.manual.index ==  null) {
            // caso esteja cadastrando um novo, irá jogar os dados do registro
            this.tratarManual()
          }
          this.$emit('onRegistroVinculado', this.limparDados(this.manual.registro))
        } else if (this.show.manual && this.resultados.length == 0) {
          if (this.manual.index ==  null) {
            // cadastro manual caso não tenha usado a busca
            this.tratarManual()
            this.$emit('onRegistroVinculado', this.limparDados(this.manual.registro))
          } else {
            // editando registro já vinculado
            this.$emit('onRegistroAtualizado', this.limparDados(this.manual.registro), this.manual.index)
          }
          // console.log('dois', this.manual.index)
          // setando resultados para array vázio para mostrar os filtros de busca
        } else if (this.resultados.length > 0) {
          // vinculando registro selecionado
          this.$emit('onRegistroVinculado', this.limparDados(this.registroSelecionado))
          // setando resultados para array vázio para mostrar os filtros de busca
          this.resultados = []
        } else {
          // seta variável para esconder registros anteriores
          this.show.registros_anteriores = false
        }

        this.manual.registro = {}
        this.manual.index = null
        this.busca = {}

        this.show = {
          manual: false,
          registros_anteriores: false
        }
        this.resultados = []
      },
      convertToSofia (registros) {
        const convert = (registro) => {
          return this.limparDados({
            registrado: null,
            tipo_registro: registro.tipo_registro,
            uf: registro.uf,
            cidade: registro.cidade,
            cartorio_id: registro.cartorio_id,
            cns: registro.num_cnj,
            nome_registrado: (this.tipo_registro == 'C') ? registro.nome_reg_1_completo : registro.nome_registrado_completo,
            nome_registrado_novo: (this.tipo_registro == 'C') ? registro.novo_nome_reg_1_completo : null,
            cpf_registrado: registro.cpf_registrado,
            cpf_conjuge: registro.cpf_conjuge_2 || null,
            conjuge: registro.nome_reg_2_completo || null,
            conjuge_novo: (this.tipo_registro == 'C') ? registro.novo_nome_reg_2_completo : null,
            regime_bens: registro.regime_bens || null,
            data_dissolucao_casamento: null,
            data_registro: registro.data_registro,
            data_ocorrido: registro.data_ocorrido,
            matricula: registro.matricula,
            matricula: registro.matricula,
            livro: registro.num_livro,
            folha: registro.num_folha,
            termo: registro.num_registro,
            nome_cartorio: registro.nome_cartorio,
            origem: registro.origem,
            genitor_um: (registro.filiacao && registro.filiacao[0]) && registro.filiacao[0].nome_filiacao_completo,
            genitor_dois: (registro.filiacao && registro.filiacao[1]) && registro.filiacao[1].nome_filiacao_completo,
          })
        }

        let converted = null

        /* converte padrão crc do elastic para o padrão de registro anterior do Sofia */
        if (Array.isArray(registros)) {
          converted = registros.map(registro => {
            return convert(registro)
          })
        } else {
          converted = convert(registros)
        }

        return converted
      },
      editRegistroAnterior (registro, index, edit) {
        Object.assign(this.manual, { index, edit, registro })

        this.show.manual = true
        this.show.registros_anteriores = true
      },
      updateManual (index, registro) {
        Object.assign(this.manual, { index, registro })
      },
      tratarManual () {
        // função responsável por vincular dados do registro no
        // no cadastro manual do registro anterior
        // tais como genitores, nome registrado para casamento
        switch (this.manual.registro.tipo_registro) {
        case 'N': case 'O':
          const { genitores } = this.propData
          if (genitores.length > 0) {
            Object.assign(this.manual.registro, {
              genitor_um: genitores[0] && genitores[0].pessoa.nome || null,
              genitor_dois: genitores[1] && genitores[1].pessoa.nome || null
            })
          }
          break
        }
      },
      getRegistrosBusca (registros, busca) {
        this.resultados = registros
        this.resultados.map(registro => registro.origem = 'CRC')
        this.tipo_registro = busca.tipo_registro
        this.busca = busca

        if (this.resultados.length === 0) {
          objSwal.error.title = "Não houve nenhum resultado na busca"
          objSwal.error.text = ''
          Swal.fire(objSwal.error)
        }
      },
      onHideModal () {
        this.show.registros_anteriores = false
        this.show.manual = false
        this.busca = {}
        this.resultados = []
      },
      ordenacaoChanged () {
        this.resultados.sort((a, b) => {
          if (a[this.ordenacao.value] < b[this.ordenacao.value]) return -1
          if (a[this.ordenacao.value] > b[this.ordenacao.value]) return 1
          return 0
        })
      },
      reset () {
        this.registroSelecionado = null
      },
      updateRegistroSelecionado (registroSelecionado) {
        this.registroSelecionado = registroSelecionado
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';

  .RegistrosAnteriores {
    &--collapse{
      background-color: black;
    }

    &--modal {
      width: 100%;

      & .modal-body {
        padding: 0 15px;
      }
    }


    @media only screen and (max-width: 1600px) {
      &_resultado {
        max-height: 33em !important;
        overflow: auto !important;
      }
    }

    @media only screen and (min-width: 1650px) {
      &_resultado {
        max-height: 40em !important;
        overflow: auto !important;
      }
    }

    &--hr {
      border-color: $color-gray;
    }

    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;
    }
  }

  .btn-add-registro:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
